module.exports = __webpack_public_path__ + "static/img/img-login.9fa27bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img-login.png
// module id = QLn5
// module chunks = 0